import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import MenuLateral from "./MenuLateral";
import NavMenu from "./Nav";
import servicosImagens from "../../servicos/servicos-imagens";
import { toast, ToastContainer } from "react-toastify";
import Delete from "../../img/svgs/Delete";
import { basePath } from "../../utils/baseUrl";

const AdicionarImagem = () => {
    const [uploadImagens, setUploadImagens] = useState([]);
    const [listaImagens, setListaImagens] = useState([]);
    const [editado, setEditado] = useState();
    const { state } = useLocation();
    const produto = state?.produto;

    useEffect(() => {
        servicosImagens.listarPorIdProduto(produto.id_produto).then(response => {
            if (response.status === 200) {
                setListaImagens(response.data)
            }
        }).catch(error => console.log(error))
    }, [produto?.id_produto, editado]);
    
    const handleArquivoChange = (e) => {
        setUploadImagens(e.target.files);
    }

    const handleEditado = () => {
        if (editado === true) {
            return false;
        }
        return true;
    }

    const adicionarImagem = () => {
        let aux = {
            arquivo: uploadImagens
        }
        if (uploadImagens.length > 0) {
            servicosImagens.create(produto.id_produto, aux.arquivo).then(response => {
                if (response.status === 201) {
                    toast.success("Imagem adicionada com sucesso!", {
                        theme: "colored",
                    });
                    setEditado(handleEditado());
                    let arq = document.querySelector("#arquivo");
                    arq.value = "";
                } else {
                    toast.error("Não foi possível adicionar a imagem.", {
                        theme: "colored",
                    });
                    return;
                }
            }).catch(
                e => {
                    console.log(e);
                    toast.error("Não foi possível adicionar a imagem.", {
                        theme: "colored",
                    });
                    return;
                }
            )
        } else {
            toast.warning('Por favor selecione uma imagem para adicionar!')
        }
    }

    const deletarImg = (id) => {
        let confirm = window.confirm("Você deseja realmente deletar a imagem? ");
        if (confirm) {
            servicosImagens.deleteImagem(id).then(response => {
                if (response.status === 200) {
                    toast.success('Imagem deletada com sucesso');
                    setEditado(handleEditado());

                } else {
                    toast.error('Não foi possível deletar a imagem');
                }
            }).catch(
                error => {
                    console.log(error);
                    toast.error('Não foi possível deletar a imagem');
                }
            )

        }
    }

    const ListaImagens = () => {
        return <>
            <div className="d-flex col mt-5">
                {listaImagens.map(item => {
                    return <div key={item.filename} className="p-2 d-flex row">
                        <div className="w-100 d-flex justify-content-center"><img className="rounded-2" style={{ width: 100, height: 100 }} src={`${basePath}/${item.filename}`} alt={item.filename} /></div>
                        <div className="w-100 d-flex justify-content-center"><button className="btn-icones rounded  w-25 mt-2" onClick={() => deletarImg(item.id_imagem)}><Delete /></button></div>
                    </div>
                })}
            </div>
        </>
    }

    return <>
        <NavMenu />
        <ToastContainer />
        <div className="d-flex container">
            <div className="w-25">
                <MenuLateral />
            </div>
            <div className="w-75 container">
                <div className="d-flex row align-items-center justify-content-center">
                    <table className="mt-5">
                        <thead>
                            <tr>
                                <th>Id Produto:</th>
                                <th>Produto:</th>
                                <th>Categoria:</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><span className="subtitulo">{produto?.id_produto}</span></td>
                                <td><span className="subtitulo">{produto?.nome}</span></td>
                                <td><span className="subtitulo"> {produto?.categoria === 1 ? "SIMPLES" : "PRODUÇÃO"}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <ListaImagens />
                {/* <label htmlFor="nome" className="form-label label-text subtitulo2 mb-5 mt-3">Imagens do produto</label> */}
                <input
                    className="d-flex justify-content-center btn-icones rounded ms-1 align-items-center mt-4"
                    type="file"
                    multiple
                    name="arquivo"
                    id="arquivo"
                    onChange={(e) => handleArquivoChange(e)}>
                </input>
                <button className="btn-icones p-1 rounded-3 mt-3" onClick={() => adicionarImagem()}>adiconar imagens</button>
            </div>
        </div>
    </>
}

export default AdicionarImagem;